<template>
  <div>
    <Header :title="'创建讣告'" />
    <div class="container">
      <div class="header-top">
        <div class="title">署名</div>
        <div class="rank-btn">
          <i class="iconfont">&#xe609;</i>
          <span>排序</span>
        </div>
      </div>
      <div class="group-list">
        <div v-for="(item, index) of groupList" :key="index" class="group-item">
          <div class="group-info">
            <div class="group-index">第{{ index + 1 }}组</div>
            <div v-if="item[0] && item[0].relation && item[0].name" class="info">{{ item[0].relation + ' | ' + item[0].name }}</div>
          </div>
          <div class="btn-wrap">
            <i class="iconfont" @click="doEdit(index)">&#xe606;</i>
            <i class="iconfont" @click="doDel(index)">&#xe63d;</i>
          </div>
        </div>
      </div>
      <div class="add-btn" @click="addGroup">
        <i class="iconfont">&#xe7b0;</i>
        <span>新增分组</span>
      </div>
      <div class="save-btn" @click="doSaveSign">保存署名</div>
    </div>
  </div>
</template>

<script>
import Storage from '@/utils/storage'
import Header from '@/components/Header/Index'
export default {
  name: 'SignGroupList',
  components: {
    Header
  },
  data() {
    return {
      groupList: []
    }
  },
  beforeRouteLeave(to, from, next) {
    console.log(to, from)
    if (to.fullPath === '/Obituary/SignGroup/Edit') {
      next()
    } else {
      Storage.localRemove('curSignGroupEditInfo')
      next()
    }
  },
  mounted() {
    if (Storage.localGet('curSignGroupList')) {
      this.groupList = Storage.localGet('curSignGroupList')
      if (Storage.localGet('curSignGroupEditInfo')) {
        const editInfo = Storage.localGet('curSignGroupEditInfo')
        this.groupList[editInfo.index] = editInfo.info
      }
    }
  },
  methods: {
    addGroup() {
      this.groupList.push([])
    },
    doDel(index) {
      this.groupList.splice(index, 1)
    },
    doEdit(index) {
      const info = {
        index: index,
        info: this.groupList[index]
      }
      Storage.localSet('curSignGroupList', this.groupList)
      Storage.localSet('curSignGroupEditInfo', info)
      this.$router.push('/Obituary/SignGroup/Edit')
    },
    doSaveSign() {
      Storage.localSet('curSignGroupList', this.groupList)
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  margin: 24px 15px 15px;
  padding-bottom: 65px;
  .header-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    .title {
      font-weight: bold;
    }
    .rank-btn {
      color: #d08d04;
      display: flex;
      align-items: center;
      i {
        margin-right: 3px;
      }
    }
  }
  .group-list {
    .group-item {
      margin-bottom: 15px;
      height: 70px;
      background: #fff;
      border-radius: 6px;
      padding: 0px 16px;
      box-shadow: 0px 0px 7px 3px rgba(0,0,0,0.1);
      display: flex;
      .group-info {
        flex: 1;
        padding: 14px 0px;
        .group-index {
          font-size: 14px;
          font-weight: bold;
        }
        .info {
          margin-top: 12px;
          font-size: 12px;
          color: #b2b2b2;
        }
      }
      .btn-wrap {
        padding-top: 12px;
        i {
          margin: 0px 15px;
          color: #b3b3b3;
        }
      }
    }
  }
  .add-btn {
    margin-bottom: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    background: #fff;
    border-radius: 6px;
    box-shadow: 0px 0px 7px 3px rgba(0,0,0,0.1);
    font-size: 17px;
    color: #f3a914;
    letter-spacing: 2px;
    i {
      margin-right: 4px;
    }
  }
  .save-btn {
    position: fixed;
    bottom: 20px;
    left: 15px;
    right: 15px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border-radius: 6px;
    background: linear-gradient(to right, #f2a612, #f7c827);
    font-size: 16px;
    color: #fff;
    letter-spacing: 2px;
  }
}
</style>
